import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';

interface CancelIconProps {
  cancelVerification: boolean;
  active: boolean;
}

export const CancelIcon: React.FC<CancelIconProps> = props => {
  const { t, tk } = useTranslation('projectLng');
  return (
    <>
      {props.cancelVerification && props.active && (
        <OverlayTrigger
          overlay={
            <Tooltip>{t(tk.projects.cancelVerificationWaiting)}</Tooltip>
          }
        >
          <div className="px-2">
            <Icon.BackspaceReverse className="icon-red" />
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};
